module.exports = __webpack_public_path__ + "static/media/marineparade_1.1c07bdad.jpg";